import {Component, Input, ViewChild} from '@angular/core';
import {AjaxService} from 'AjaxService';
import {SpinnerService} from '@services/spinner.service';
import {StaticVorlagenType, StaticVorlagenGruppen} from '@enums/staticVorlagen.enum';
import {DxFormComponent} from 'devextreme-angular/ui/form';
import { EntityArt } from '@helper/enums/entityArt.enum';

@Component({
    selector: 'cz-stammblatt',
    templateUrl: 'stammblatt.component.html',
    styleUrls: ['./stammblatt.component.css'],
    standalone: false
})
export class StammblattComponent {
  @ViewChild('form', {static: false}) form: DxFormComponent;

  loading: boolean;
  @Input() entityArt: number;
  @Input() entityId: number;
  @Input() ues: any[] = [];
  eArt = EntityArt;

  isPopupVisible: boolean = false;
  canCreate: boolean = false;
  spezialContext: any = {};

  constructor(private ajaxService: AjaxService, private spinnerService: SpinnerService) {
    this.onClickClose = this.onClickClose.bind(this);
    this.onClickErstellen = this.onClickErstellen.bind(this);
    this.getDisplayValue = this.getDisplayValue.bind(this);
  }

  onClick_HE_AngUntr() {
    this.build(StaticVorlagenGruppen.Haupteinrichtung, StaticVorlagenType.Stammblatt_HE_Angebot_Untereinrichtung, 'Stammblatt_HE_Angebot_Untereinrichtung');
  }

  onClick_HE_PersBlatt() {
    this.build(StaticVorlagenGruppen.Haupteinrichtung, StaticVorlagenType.Stammblatt_HE_Personaldatenblatt, 'Stammblatt_HE_Personaldatenblatt');
  }

  onClick_HE_BesVork() {
    this.build(StaticVorlagenGruppen.Haupteinrichtung, StaticVorlagenType.Stammblatt_HE_Besondere_Vorkommnisse, 'Stammblatt_HE_Besondere_Vorkommnisse');
  }

  onClick_UE_PersonalUebersicht() {
    this.build(StaticVorlagenGruppen.Untereinrichtung, StaticVorlagenType.Stammblatt_UE_Personenuebersicht, 'Stammblatt_Einrichtung_Personenuebersicht');
  }

  build(grp: StaticVorlagenGruppen, vt: StaticVorlagenType, fileName: string) {
    if (vt === StaticVorlagenType.Stammblatt_HE_Angebot_Untereinrichtung) {
      this.isPopupVisible = true;
    } else {
      const req = {staticVorlagenGruppe: StaticVorlagenGruppen.toNumber(grp), entityId: this.entityId, staticVorlagenType: vt};

      this.startLoading();
      this.ajaxService.post<string>('api/vorlagenVerwaltung/BuildStammblatt', req).subscribe({
        next: (response) => {
          if (response) {
            this.ajaxService.download('/api/Dokument/DownloadAndDelete?fileName=' + response + '&dokumentName=Stammblatt', fileName + '.pdf');
          }
          this.stopLoading();
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        },
      });
    }
  }

  private startLoading() {
    this.spinnerService.show();
    this.loading = true;
  }

  private stopLoading() {
    this.spinnerService.hide();
    this.loading = false;
  }

  //-------

  getDisplayValue(item) {
    if (!item) {
      return null;
    }

    let result = '';

    if (item.isActive !== true) {
      result += '(inaktiv) ';
    }

    result += item.name;

    if (item.namenszusatz && item.namenszusatz.length > 0) {
      result += ' / ' + item.namenszusatz;
    }

    return result;
  }

  onClickClose() {
    this.form.instance.getEditor('ues').option('value', []);
    this.isPopupVisible = false;
  }

  onHiddenPopup(e) {
    this.form.instance.getEditor('ues').option('value', []);
  }

  onClickErstellen() {
    const validationResult = this.form.instance.validate();

    if (validationResult.isValid) {
      const req = {
        entityId: this.entityId,
        staticVorlagenGruppe: StaticVorlagenGruppen.toNumber(StaticVorlagenGruppen.Haupteinrichtung),
        staticVorlagenType: StaticVorlagenType.Stammblatt_HE_Angebot_Untereinrichtung,
        ues: this.spezialContext.ues,
      };

      this.startLoading();
      this.ajaxService.post<string>('api/vorlagenVerwaltung/BuildStammblatt', req).subscribe({
        next: (response) => {
          if (response) {
            this.form.instance.getEditor('ues').option('value', []);
            this.ajaxService.download('/api/Dokument/DownloadAndDelete?fileName=' + response + '&dokumentName=Stammblatt', 'Stammblatt_HE_Angebot_Untereinrichtung.pdf');
            this.isPopupVisible = false;
          }
          this.stopLoading();
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        }
      });
    }
  }
}
